var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03_Login"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1436,
    transform: "translate(-931 -894)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -32.5,
    y: -284.5,
    width: 479,
    height: 589,
    rx: 19.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -32.5,
    y: -284.5,
    width: 479,
    height: 589,
    rx: 19.5,
    stroke: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -32.5,
    y: -284.5,
    width: 479,
    height: 589,
    rx: 19.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33925 1.75313C7.17128 1.37504 5.90159 1.90095 5.34305 2.9942L4.67156 4.30851C4.59178 4.46468 4.46477 4.59169 4.3086 4.67147L2.9943 5.34295C1.90105 5.9015 1.37513 7.17119 1.75322 8.33915L2.20777 9.74332C2.26178 9.91016 2.26178 10.0898 2.20777 10.2567L1.75322 11.6608C1.37513 12.8288 1.90105 14.0985 2.9943 14.6571L4.3086 15.3285C4.46477 15.4083 4.59178 15.5353 4.67156 15.6915L5.34305 17.0058C5.90159 18.0991 7.17128 18.625 8.33925 18.2469L9.74341 17.7923C9.91025 17.7383 10.0899 17.7383 10.2567 17.7923L11.6609 18.2469C12.8289 18.625 14.0986 18.0991 14.6572 17.0058L15.3286 15.6915C15.4084 15.5353 15.5354 15.4083 15.6916 15.3285L17.0059 14.6571C18.0992 14.0985 18.6251 12.8288 18.247 11.6608L17.7924 10.2567C17.7384 10.0898 17.7384 9.91016 17.7924 9.74332L18.247 8.33915C18.6251 7.17119 18.0992 5.9015 17.0059 5.34295L15.6916 4.67147C15.5354 4.59169 15.4084 4.46468 15.3286 4.30851L14.6572 2.9942C14.0986 1.90095 12.8289 1.37504 11.6609 1.75313L10.2567 2.20768C10.0899 2.26168 9.91025 2.26169 9.74341 2.20768L8.33925 1.75313ZM5.63322 9.79774L6.81174 8.61915L9.16875 10.9762L13.8828 6.2622L15.0613 7.4407L9.16875 13.3332L5.63322 9.79774Z",
    fill: "#09CB11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 304"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8103ccedb8f6cc7646b595352a907ecd.svg";
export { ForwardRef as ReactComponent };